import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoalLeadFields from './icon-goal-lead-fields.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoalLeadFields {...validProps} />;
}
SvgComponent.iconName = 'goal-custom-fields';

/**
 * @deprecated This is a legacy icon
 */
export const GoalLeadFieldsIcon = svgIconWrapper(SvgComponent);
